import React, { type HTMLAttributes } from 'react'

const Flex: React.FC<
  HTMLAttributes<HTMLDivElement> & {
    centered?: boolean
    column?: boolean
    inline?: boolean
    right?: boolean
    stretch?: boolean
    wrapped?: boolean
  }
> = ({ centered, column, stretch, wrapped, inline, right, ...rest }) => (
  <div
    css={{
      display: inline ? 'inline-flex' : 'flex',
      flexDirection: column ? 'column' : 'row',
      ...(stretch && { width: '100%' }),
      ...(wrapped && { flexWrap: 'wrap' }),
      ...(right && { marginLeft: 'auto' }),
      ...(centered && { alignItems: 'center' })
    }}
    {...rest}
  />
)

export default Flex
